import React from "react";
import {Typography} from "@mui/material";
import {app} from "../../konstants";
import "./logo.css";
import {logo} from "../../images";

const Logo = (props) => {
    return <div className="logo">
        <Typography variant="h4">
            {app.name}
        </Typography>
        <div className="ia">
            <img src={logo}/>
        </div>
        <Typography variant="body1">
            {app.description}
        </Typography>
    </div>
};

export default Logo;
